import { render, staticRenderFns } from "./AdminNavigationV2.vue?vue&type=template&id=62403046"
import script from "./AdminNavigationV2.vue?vue&type=script&lang=ts"
export * from "./AdminNavigationV2.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports